// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DealershipService } from '@services/dealership.service';
import { MaterialModule } from '../../shared/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { CreateDealModule } from './create-deal/create-deal.module';
import { DealCardComponent } from './deal-card/deal-card.component';
import { DealsRoutingModule } from './deals-routing.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, CreateDealModule, DealsRoutingModule, FormsModule, MaterialModule, PipesModule, ReactiveFormsModule, SharedModule],
    providers: [DealershipService],
    exports: [DealCardComponent],
})
export class DealsModule {}
